export const CONFIG = {
  SITE_NAME: 'ESRF',
  ICATPLUS_URL: 'https://icatplus.esrf.fr/',
  doi: {
    prefix: '10.15151',
  },
  landingPage: [
    {
      title: 'About the portal',
      texts: [
        {
          text: 'This portal centralizes the <a href="https://www.esrf.fr/DOI" target="_blank" rel="noreferrer">DOI</a> services offered by the ESRF to access data stored at the facility as part of its data policy. Data referenced by ESRF DOIs can be found on the ESRF <a href="https://data.esrf.fr" target="_blank" rel="noreferrer">Data Portal</a>.',
        },
        {
          text: 'You can <a href="https://youtu.be/dPeN855-Mu4" target="_blank" rel="noreferrer">mint a DOI</a> for a subset of data.',
        },
        {
          text: 'Please contact us at <a href="mailto:dataportalrequests@esrf.fr">dataportalrequests@esrf.fr</a>',
        },
      ],
      footer:
        'Access to data is governed by the <a href="https://www.esrf.fr/files/live/sites/www/files/about/organisation/ESRF%20data%20policy-web.pdf" target="_blank" rel="noreferrer">ESRF data policy</a>.',
    },
    {
      title: 'DOI Resolver',
      texts: [
        {
          text: 'The search engine below only searches DOIs that have been minted at the ESRF.',
        },
        {
          text: 'Use the <a href="https://doi.org" target="_blank" rel="noreferrer">doi.org</a> search engine for other DOIs.',
        },
        {
          text: '<a href="https://commons.datacite.org/ror.org/02550n020?client-id=inist.esrf" target="_blank" rel="noreferrer">List of all ESRF DOIs</a>',
        },
      ],
      search: {
        placeHolder: '10.15151/ESRF-ES-90632078',
        error: 'Invalid ESRF DOI',
      },
    },
    {
      title: 'About DOI',
      texts: [
        {
          text: 'The Digital Object Identifier, or <a href="http://www.esrf.eu/home/UsersAndScience/UserGuide/esrf-data-policy/doi.html" target="_blank" rel="noreferrer">DOI</a>, is a code composed of digits and characters. It identifies data in a unique and permanent way, thereby allowing data to be referenced worldwide.',
        },
        {
          text: 'The DOI has two parts: a prefix and a suffix, separated by a slash. At the ESRF, the prefix is <strong>10.15151</strong> and the suffix can start with:',
        },
        {
          text: '<ul><li><code>ESRF-ES-*</code> — for a session</li><li><code>ESRF-DC-*</code> — for a subset of data</li><li><code>ESRF-INSTR-*</code> — for an instrument</li></ul>',
        },
        {
          text: 'Refer to the DOI <a href="http://www.esrf.eu/home/UsersAndScience/UserGuide/esrf-data-policy/doi/doi---concepts.html" target="_blank" rel="noreferrer">concepts page</a> to find out what a session is.',
        },
      ],
    },
  ],
};
